const THUMBNAIL_SRC = 'https://cdn.anytimebooking.io/unit/';
// ${unitId}-1${serverSuffix}.jpg?ts${cacheBustTimeStamp}`

// TODO: not the right place for this, it's a pure function that does not interact with the DOM
function buildUnitAddressString(city, state) {
    if (!city || !state) return '';

    // split, capitalise and rejoin each word in a string
    const capitaliseWords = str =>
        str
            .split(' ')
            .map(capitaliseFirstLetter)
            .join(' ');

    return `${capitaliseWords(city)}, ${capitaliseWords(state)}`;
}

function isEmpty(value) {
    if (value == null) return true;
    if (Array.isArray(value)) return value.length === 0;
    if (typeof value === 'object') return Object.keys(value).length === 0;
    return false;
}

export { 
    buildUnitAddressString,
    isEmpty
};